import React from "react";
import { Biscuit } from "../../../../utils";
import t from "../../../helpers/t";
import SlotsView from "../components/SlotsView";
import { rbac } from "../index";

const ItemMobile = (props) => {
  const {
    dispatch,
    isSubmenuOpen,
    facility,
    getLocationById,
    _exchangeLabel,
    onShowTrackings,
    onShowGenerateNewPin,
    onRemoveFacility,
    onGetQRCodeHandler,
    onOpenDoor,
    onOpenSlot,
    onRemoveSlot,
    showStatus,
    index,
    openSubmenuHandle,
    onShowSlotHistories,
  } = props;
  return (
    <>
      <div className="hide-for-large">
        <div
          className="inb-c-item inb-c-item--order row"
          style={isSubmenuOpen(index) ? { paddingBottom: "0px" } : { padding: "0px" }}
          key={facility.id}
        >
          <aside className="inb-c-item__actions">
            <button
              className="button round"
              type="button"
              style={{ opacity: 0, cursor: "inherit" }}
            >
              {" "}
              ...{" "}
            </button>
            <button
              className={
                "button round inb-toggle-details inb-toggle-details-" +
                Biscuit.get("user.client_id")
              }
              type="button"
              title="Wechseln zu Ladestationen"
              onClick={(e) => openSubmenuHandle(e, index)}
            >
              <i className="fi fi-list-thumbnails"></i>
              <div className="badge primary reservations-count">
                {facility.facility_slots === undefined ? 0 : facility.facility_slots.length}
              </div>
            </button>
          </aside>
          <div
            className="inb-c-item row"
            style={{ width: "calc(100% - 35px)", marginRight: "0px", padding: "0px", border: "0" }}
          >
            <div
              className="medium-12 small-12 column inb-order-big show-label"
              title={t("designation")}
            >
              {facility.name !== null
                ? facility.name
                : t(_exchangeLabel("facility"), null, "capital") + " " + facility.id}
            </div>
            <div
              className="medium-12 small-12 medium-offset-0 column show-label"
              title={t("location", null, "capital")}
            >
              {getLocationById(facility.location_id)}
            </div>
            <div
              className="medium-12 small-12 medium-offset-0 column show-label"
              title={t("facility_type")}
            >
              {facility.facility_type !== null ? t(facility.facility_type) : t("cyclepoint")}
            </div>
            <div
              className="medium-12 small-12 medium-offset-0 column show-label"
              title={t("error_text")}
            >
              &nbsp;
            </div>
            <div
              className="medium-12 small-12 medium-offset-0 column show-label"
              title={t("last_modified_at")}
            >
              {facility.modified}
            </div>

            <div
              className="medium-12 small-12 medium-offset-0 column item-button-group"
              style={{ display: "block", position: "relative", marginLeft: "10%" }}
            >
              {facility.facility_type === "general_paketin_admin" &&
                (facility.booking_type === "none" ||
                  (facility.booking_type === "contingent" &&
                    facility.facility_slots.length < 1)) && (
                  <div className="button-container left">
                    <a
                      href="#"
                      title={t("show trackings")}
                      data-inb-action-link="list"
                      onClick={() => onShowTrackings(facility, "facility")}
                    >
                      <button type="button" className="inb-round-btn hollow round float-left">
                        <div className="inb-fi-list"></div>
                      </button>
                    </a>
                  </div>
                )}
              {rbac.hasPermission("openDoor") &&
                facility.facility_type === "general_paketin_pin" &&
                Biscuit.get("user.is_superuser") === "true" && (
                  <div className="button-container left">
                    <a
                      href="#"
                      title={t("show generate new pin")}
                      data-inb-action-link="list"
                      onClick={() => onShowGenerateNewPin(facility)}
                    >
                      <button type="button" className="inb-round-btn hollow round float-left">
                        <div className="fi fi-wrench"></div>
                      </button>
                    </a>
                  </div>
                )}
              {rbac.hasPermission("editFacility") && (
                <div className="button-container left">
                  <a href={"/facilities/" + facility.id} title="" data-inb-action-link="edit">
                    <button type="button" className="inb-round-btn hollow round float-left">
                      <div className="inb-fi-edit"></div>
                    </button>
                  </a>
                </div>
              )}
              {rbac.hasPermission("delete") && (
                <div className="button-container">
                  <a href="#" className="inb-reservation__pdf2" title={t("delete")}>
                    <button
                      type="button"
                      className="inb-round-btn hollow round float-left"
                      onClick={() => onRemoveFacility(facility)}
                    >
                      <div className="inb-fi-remove"></div>
                    </button>
                  </a>
                </div>
              )}
              {facility.facility_type === "general_paketin_admin" && (
                <>
                  <div className="button-container left">
                    <a href="#" title={t("getQRCode")}>
                      <button
                        type="button"
                        className="inb-round-btn hollow round float-left"
                        key={"a_button_facility_qr_" + facility.id}
                        onClick={() => onGetQRCodeHandler(facility)}
                      >
                        <div className="inb-fi-qrcode"> </div>
                      </button>
                    </a>
                  </div>
                  {(facility.booking_type === "none" ||
                    (facility.facility_slots.length === 0 &&
                      facility.booking_type === "contingent")) && (
                    <div className="button-container">
                      <a
                        className="inb-resource__open_door inb-c-item__open_door"
                        href="#"
                        title={t("open")}
                      >
                        <button
                          type="button"
                          className="inb-round-btn hollow round float-left"
                          onClick={() => onOpenDoor("facility", facility)}
                        >
                          <i className="fi fi-key"></i>
                          {/*<div className="inb-fi-key"> </div>*/}
                        </button>
                      </a>
                    </div>
                  )}
                </>
              )}
            </div>
            {isSubmenuOpen(index) && (
              <SlotsView
                facility={facility}
                dispatch={dispatch}
                onRemoveSlot={onRemoveSlot}
                showStatus={showStatus}
                onOpenDoor={onOpenDoor}
                onOpenSlot={onOpenSlot}
                onShowTrackings={onShowTrackings}
                onShowSlotHistories={onShowSlotHistories}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default ItemMobile;
